import { Injectable } from '@angular/core';
import { CommunicationService } from './communication.service';

@Injectable({
  providedIn: 'root',
})
export class DetailProjectService {
  constructor(private communicationService: CommunicationService) { }

  getProjectTodayMoney(id: string) {
    return this.communicationService.get('apiservices/dashboard/v1/dashboard/' + id + '/statistics/today/money', null);
  }

  getProjectTodayProduction(id: string) {
    return this.communicationService.get('apiservices/dashboard/v1/dashboard/' + id + '/statistics/today/production', null);
  }

  getProjectAnnual(id: string) {
    return this.communicationService.get('apiservices/dashboard/v1/dashboard/' + id + '/statistics/annual', null);
  }

  getProjectPerformance(id: string) {
    return this.communicationService.get('apiservices/dashboard/v1/dashboard/ ' + id + '/statistics/performance', null);
  }

  getIfIsStageActive(index: number, detailProject: any): boolean {
    const stages = detailProject?.postal_code_investment_stages;
    if (!stages || !stages[index]) {
      return false;
    }

    const currentStageDate = new Date(stages[index].start_date);
    const now = new Date();

    // Check if the current stage has started
    if (now < currentStageDate) {
      return false;
    }

    // Check if the next stage exists
    const nextStage = stages[index + 1];
    if (nextStage) {
      const nextStageDate = new Date(nextStage.start_date);
      // If now is >= next stage, then this stage is passed (not active)
      if (now >= nextStageDate) {
        return false;
      }
    }

    return true;
  }

  isStagePassed(index: number, detailProject: any): boolean {
    const stages = detailProject?.postal_code_investment_stages;
    if (!stages || !stages[index]) {
      return false;
    }

    const nextStage = stages[index + 1];
    if (nextStage) {
      const nextStageDate = new Date(nextStage.start_date);
      const now = new Date();
      // If now is >= next stage, then this stage is passed
      if (now >= nextStageDate) {
        return true;
      }
    }

    return false;
  }

  hasUserPriorityGroup(stage: any): boolean {
    if (!stage?.priority_groups) return false;
    return stage.priority_groups.some((pg: any) => pg.isEnabledForUser);
  }
}
